<app-breadcrumb
	[title]="t('إدارة اشتراكات التجار', 'Merchant Subscriptions Management', 'ניהול מנויי סוחרים')"
	[items]="[t('لوحة التحكم', 'Dashboard', 'לוח בקרה')]"
	[active_item]="t('إدارة الاشتراكات', 'Subscriptions Management', 'ניהול מנויים')"
></app-breadcrumb>

<div class="container-fluid basic_table">
	<div class="card mb-3">
		<div class="card-header d-flex justify-content-between flex-wrap gap-2">
			<h5 class="mb-0">
				{{ t('إدارة اشتراكات التجار', 'Merchant Subscriptions Management', 'ניהול מנויי סוחרים') }}
			</h5>
			<div class="d-flex gap-2">
				<button class="btn btn-dark" type="button" (click)="openCreateSubscriptionModal(createModal)">
					<i class="fa fa-plus mx-1"></i>{{ t('إنشاء اشتراك جديد', 'Create New Subscription', 'יצירת מנוי חדש') }}
				</button>
				<button class="btn btn-outline-primary" type="button" (click)="openExtensionModal(extensionModal)">
					<i class="fa fa-magic mx-1"></i>{{ t('تمديد/تعديل الاشتراك', 'Extend/Adjust Subscription', 'הארכה/עדכון מנוי') }}
				</button>
				<button class="btn btn-outline-secondary" (click)="backToPlans()">
					<i class="fa fa-arrow-left mx-1"></i>{{ t('العودة للخطط', 'Back to Plans', 'חזרה לתוכניות') }}
				</button>
				<button class="btn btn-outline-warning" (click)="refreshAll()">
					<i class="fa fa-refresh mx-1"></i>{{ t('تحديث', 'Refresh', 'רענון') }}
				</button>
			</div>
		</div>

		<div class="card-body">
			<div class="col-12" *ngIf="lastPaymentUrl">
				<div class="payment-link-box">
					<label class="form-label mb-1">
						{{ t('آخر رابط دفع تم إنشاؤه', 'Last generated payment link', 'קישור התשלום האחרון שנוצר') }}
						<span *ngIf="lastOrderId"> - {{ t('رقم الطلب', 'Order ID', 'מספר הזמנה') }}: {{ lastOrderId }}</span>
					</label>
					<div class="input-group">
						<input class="form-control" [value]="lastPaymentUrl" readonly />
						<button class="btn btn-outline-primary" type="button" (click)="copyPaymentLink()">
							<i class="fa fa-copy mx-1"></i>{{ t('نسخ الرابط', 'Copy Link', 'העתק קישור') }}
						</button>
						<a class="btn btn-outline-dark" [href]="lastPaymentUrl" target="_blank" rel="noopener noreferrer">
							<i class="fa fa-external-link mx-1"></i>{{ t('فتح الرابط', 'Open Link', 'פתח קישור') }}
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="card subscriptions-data-card mb-3 shadow-sm border-0">
		<div class="card-body p-0">

			<!-- Toolbar -->
			<div class="subscriptions-toolbar px-3 px-md-4 pt-4 pb-3">
				<div class="d-flex flex-column flex-lg-row flex-lg-wrap justify-content-lg-between align-items-lg-center gap-3">
					<div class="subscriptions-toolbar__intro">
						<h6 class="subscriptions-toolbar__title mb-1">
							<i class="fa fa-sliders me-2" aria-hidden="true"></i>
							{{ t('قائمة الاشتراكات', 'Subscription list', 'רשימת מנויים') }}
						</h6>
						<p class="subscriptions-toolbar__hint mb-0 small">
							{{
								t(
									'سجل واحد لكل تاجر — آخر حالة اشتراك. افتح التفاصيل لعرض السجل الكامل.',
									'One row per merchant (latest subscription). Open details for full history.',
									'שורה אחת לכל סוחר (מנוי אחרון). פתח פרטים להיסטוריה המלאה.'
								)
							}}
						</p>
					</div>
					<div class="subscriptions-toolbar__actions d-flex flex-wrap gap-2 align-items-center">
						<div class="form-check subscriptions-export-check mb-0">
							<input
								class="form-check-input"
								type="checkbox"
								id="exportFilteredOnly"
								[(ngModel)]="exportFilteredOnly"
								[ngModelOptions]="{standalone: true}"
							/>
							<label class="form-check-label small" for="exportFilteredOnly">
								{{ t('تصدير النتائج المصفّاة فقط', 'Export filtered rows only', 'ייצא רק שורות מסוננות') }}
							</label>
						</div>
						<button class="btn btn-outline-secondary btn-sm subscriptions-btn-icon" type="button" (click)="resetFilters()">
							<i class="fa fa-undo me-1" aria-hidden="true"></i>
							{{ t('مسح المرشحات', 'Clear filters', 'נקה מסננים') }}
						</button>
						<button class="btn btn-dark btn-sm subscriptions-btn-export" type="button" (click)="exportToCsv()">
							<i class="fa fa-download me-1" aria-hidden="true"></i>
							{{ t('تصدير CSV', 'Export CSV', 'ייצוא CSV') }}
						</button>
					</div>
				</div>
			</div>

			<!-- Filters: status + single compact grid -->
			<div class="subscriptions-filters subscriptions-filters--layout px-3 px-md-4 py-4">
				<!-- Subscription status (effective) — single control, no duplicate dropdown -->
				<div class="subscriptions-filter-block subscriptions-filter-block--status mb-4">
					<div class="subscriptions-filter-block__head">
						<span class="subscriptions-filter-block__title">
							<i class="fa fa-signal" aria-hidden="true"></i>
							{{ t('حالة الاشتراك', 'Subscription status', 'סטטוס מנוי') }}
						</span>
						<span class="subscriptions-filter-block__caption">
							{{
								t(
									'يعتمد على الحالة الفعلية (نشط / منتهي التاريخ / ملغى).',
									'Based on effective state: active, past end date, or cancelled.',
									'לפי סטטוס אפקטיבי: פעיל, תאריך סיום חלף או בוטל.'
								)
							}}
						</span>
					</div>
					<div class="subscriptions-status-segmented" role="group" [attr.aria-label]="t('فلترة الحالة', 'Status filter', 'סינון סטטוס')">
						<button
							type="button"
							class="subscriptions-quick-chip subscriptions-quick-chip--all"
							[class.subscriptions-quick-chip--selected]="filterStatus === ''"
							(click)="setStatusFilter('')"
						>
							{{ t('الكل', 'All', 'הכל') }}
							<span class="subscriptions-quick-chip__cnt">{{ latestSubscriptionsByMerchant.length }}</span>
						</button>
						<button
							type="button"
							class="subscriptions-quick-chip subscriptions-quick-chip--active"
							[class.subscriptions-quick-chip--selected]="filterStatus === 'active'"
							(click)="setStatusFilter('active')"
						>
							{{ t('نشط', 'Active', 'פעיל') }}
							<span class="subscriptions-quick-chip__cnt">{{ subscriptionStatusSummary.active }}</span>
						</button>
						<button
							type="button"
							class="subscriptions-quick-chip subscriptions-quick-chip--expired"
							[class.subscriptions-quick-chip--selected]="filterStatus === 'expired'"
							(click)="setStatusFilter('expired')"
						>
							{{ t('منتهي', 'Expired', 'פג תוקף') }}
							<span class="subscriptions-quick-chip__cnt">{{ subscriptionStatusSummary.expired }}</span>
						</button>
						<button
							type="button"
							class="subscriptions-quick-chip subscriptions-quick-chip--cancelled"
							[class.subscriptions-quick-chip--selected]="filterStatus === 'cancelled'"
							(click)="setStatusFilter('cancelled')"
						>
							{{ t('ملغي', 'Cancelled', 'מבוטל') }}
							<span class="subscriptions-quick-chip__cnt">{{ subscriptionStatusSummary.cancelled }}</span>
						</button>
					</div>
				</div>

				<hr class="subscriptions-filters-rule" />

				<!-- Search, plan, auto-renew, date range — one responsive grid -->
				<div class="row g-3 align-items-end subscriptions-filter-fields">
					<div class="col-12 col-xl-4">
						<label class="subscriptions-filter-label" for="subs-search-input">{{ t('بحث', 'Search', 'חיפוש') }}</label>
						<div class="input-group input-group-sm subscriptions-input-group subscriptions-field-tall">
							<span class="input-group-text"><i class="fa fa-search" aria-hidden="true"></i></span>
							<input
								id="subs-search-input"
								type="text"
								class="form-control subscriptions-input subscriptions-field-tall__control"
								[(ngModel)]="term"
								[ngModelOptions]="{standalone: true}"
								placeholder="{{ t('اسم التاجر، الخطة، الرقم…', 'Merchant, plan, ID…', 'סוחר, תוכנית, מזהה…') }}"
								autocomplete="off"
							/>
						</div>
					</div>
					<div class="col-12 col-md-6 col-xl-2">
						<label class="subscriptions-filter-label" for="subs-filter-plan">{{ t('الخطة', 'Plan', 'תוכנית') }}</label>
						<select
							id="subs-filter-plan"
							class="form-select form-select-sm subscriptions-input subscriptions-field-tall__control"
							[(ngModel)]="filterPlanId"
							[ngModelOptions]="{standalone: true}"
						>
							<option [ngValue]="null">{{ t('الكل', 'All', 'הכל') }}</option>
							<option *ngFor="let p of uniquePlanOptions" [ngValue]="p.id">{{ getPlanDisplayName(p) }}</option>
						</select>
					</div>
					<div class="col-12 col-md-6 col-xl-2">
						<label class="subscriptions-filter-label" for="subs-filter-renew">{{ t('تجديد تلقائي', 'Auto renew', 'חידוש אוטומטי') }}</label>
						<select
							id="subs-filter-renew"
							class="form-select form-select-sm subscriptions-input subscriptions-field-tall__control"
							[(ngModel)]="filterAutoRenew"
							[ngModelOptions]="{standalone: true}"
						>
							<option value="">{{ t('الكل', 'All', 'הכל') }}</option>
							<option value="true">{{ t('نعم', 'Yes', 'כן') }}</option>
							<option value="false">{{ t('لا', 'No', 'לא') }}</option>
						</select>
					</div>
					<div class="col-6 col-md-6 col-xl-2">
						<label class="subscriptions-filter-label" for="subs-filter-date-from">{{ t('بداية من', 'Start from', 'התחלה מ') }}</label>
						<div class="input-group input-group-sm subscriptions-date-input-group subscriptions-field-tall">
							<span class="input-group-text"><i class="fa fa-calendar-o" aria-hidden="true"></i></span>
							<input
								id="subs-filter-date-from"
								type="date"
								class="form-control subscriptions-input subscriptions-date-input subscriptions-field-tall__control"
								[(ngModel)]="filterDateFrom"
								[ngModelOptions]="{standalone: true}"
								[max]="filterDateTo || null"
							/>
						</div>
					</div>
					<div class="col-6 col-md-6 col-xl-2">
						<label class="subscriptions-filter-label" for="subs-filter-date-to">{{ t('بداية إلى', 'Start until', 'התחלה עד') }}</label>
						<div class="input-group input-group-sm subscriptions-date-input-group subscriptions-field-tall">
							<span class="input-group-text"><i class="fa fa-calendar-o" aria-hidden="true"></i></span>
							<input
								id="subs-filter-date-to"
								type="date"
								class="form-control subscriptions-input subscriptions-date-input subscriptions-field-tall__control"
								[(ngModel)]="filterDateTo"
								[ngModelOptions]="{standalone: true}"
								[min]="filterDateFrom || null"
							/>
						</div>
					</div>
				</div>
				<p class="subscriptions-date-footnote mb-0 mt-2 small">
					<i class="fa fa-info-circle me-1" aria-hidden="true"></i>
					{{
						t(
							'يجب أن تكون «من» ضمن النطاق، ولا يُعرض صف إذا تجاوز «إلى» تاريخ «بداية إلى».',
							'Start date must fall in the range; rows whose end date is after «Start until» are hidden.',
							'תאריך ההתחלה חייב להיות בטווח; שורות שתאריך הסיום שלהן מאוחר מ«התחלה עד» יוסתרו.'
						)
					}}
				</p>
			</div>

			<div class="subscriptions-results-strip px-3 px-md-4 py-2">
				<div class="d-flex flex-wrap align-items-center justify-content-between gap-2">
					<div class="subscriptions-results-strip__counts d-flex align-items-center gap-2 flex-wrap">
						<span class="subscriptions-stat subscriptions-stat--primary">
							<strong>{{ filteredSubscriptions.length }}</strong>
							<span class="subscriptions-stat__label">{{ t('معروض', 'shown', 'מוצג') }}</span>
						</span>
						<span class="subscriptions-stat-divider d-none d-sm-inline" aria-hidden="true"></span>
						<span class="subscriptions-stat subscriptions-stat--muted">
							<strong>{{ latestSubscriptionsByMerchant.length }}</strong>
							<span class="subscriptions-stat__label">{{ t('إجمالي التجار', 'total merchants', 'סה״כ סוחרים') }}</span>
						</span>
						<span class="subscriptions-stat-divider d-none d-sm-inline" aria-hidden="true"></span>
						<span class="subscriptions-stat subscriptions-stat--muted">
							<strong>{{ subscriptions.length }}</strong>
							<span class="subscriptions-stat__label">{{ t('كل السجلات', 'all records', 'כל הרשומות') }}</span>
						</span>
					</div>
					<span class="subscriptions-results-strip__meta small">
						<i class="fa fa-info-circle me-1 opacity-75" aria-hidden="true"></i>
						{{ t('يتم التحديث فورياً عند تغيير المرشحات.', 'Updates instantly when filters change.', 'מתעדכן מיד בעת שינוי המסננים.') }}
					</span>
				</div>
			</div>

			<!-- Table -->
			<div class="table-responsive subscriptions-table-wrap">
				<table class="table table-hover subscriptions-table mb-0 align-middle text-center">
					<thead class="subscriptions-table-head">
						<tr>
							<th class="subscriptions-col-num">#</th>
							<th class="text-start">{{ t('التاجر', 'Merchant', 'סוחר') }}</th>
							<th class="text-start">{{ t('الخطة', 'Plan', 'תוכנית') }}</th>
							<th>{{ t('الحالة', 'Status', 'סטטוס') }}</th>
							<th>{{ t('من', 'Start', 'התחלה') }}</th>
							<th>{{ t('إلى', 'End', 'סיום') }}</th>
							<th>{{ t('المستندات', 'Documents', 'מסמכים') }}</th>
							<th>{{ t('الشركات', 'Companies', 'חברות') }}</th>
							<th class="subscriptions-col-actions">{{ t('الإجراءات', 'Actions', 'פעולות') }}</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let item of filteredSubscriptions; let i = index" class="subscriptions-table__row">
							<td class="subscriptions-col-num text-secondary fw-medium">{{ i + 1 }}</td>
							<td class="text-start">
								<div class="merchant-name-cell">
									<span class="merchant-name-cell__name">{{ getMerchantName(item.merchant_id) }}</span>
									<button
										type="button"
										class="btn btn-sm btn-outline-primary merchant-name-cell__details"
										[title]="t('عرض التفاصيل والسجل الكامل', 'View details & full history', 'פרטים והיסטוריה מלאה')"
										(click)="openMerchantDetails(detailsModal, item.merchant_id)"
									>
										<i class="fa fa-info-circle" aria-hidden="true"></i>
										<span class="d-none d-md-inline">{{ t('تفاصيل', 'Details', 'פרטים') }}</span>
									</button>
								</div>
								<div class="small text-muted">#{{ item.merchant_id }}</div>
							</td>
							<td class="text-start">{{ getPlanDisplayName(item.plan) }}</td>
							<td>
								<span
									class="badge rounded-pill subscriptions-status subscriptions-status--{{ getEffectiveSubscriptionStatus(item) }}"
									[title]="item.status ? ('API: ' + item.status) : ''"
								>
									{{ subscriptionEffectiveStatusLabel(item) }}
								</span>
							</td>
							<td class="text-nowrap small">{{ item.start_date | date : "dd/MM/yyyy" }}</td>
							<td class="text-nowrap small">{{ item.end_date | date : "dd/MM/yyyy" }}</td>
							<td class="small">{{ formatDocumentsUsage(item) }}</td>
							<td class="small">{{ formatCompaniesUsage(item) }}</td>
							<td class="subscriptions-col-actions">
								<div class="btn-group btn-group-sm subscriptions-action-group" role="group">
									<button
										*ngIf="item.pending_payment_link?.payment_url"
										type="button"
										class="btn btn-outline-secondary"
										[title]="t('نسخ رابط الدفع المعلّق', 'Copy pending payment link', 'העתק קישור תשלום ממתין')"
										(click)="copyPaymentLink(item.pending_payment_link?.payment_url)"
									>
										<i class="fa fa-copy" aria-hidden="true"></i>
									</button>
									<button
										*ngIf="getEffectiveSubscriptionStatus(item) === 'active'"
										type="button"
										class="btn btn-outline-danger"
										[title]="t('تعطيل الاشتراك', 'Disable subscription', 'השבת מנוי')"
										(click)="disableActiveSubscription(item.merchant_id)"
									>
										<i class="fa fa-ban" aria-hidden="true"></i>
									</button>
								</div>
							</td>
						</tr>
						<tr *ngIf="filteredSubscriptions.length === 0">
							<td colspan="9" class="subscriptions-empty py-5">
								<i class="fa fa-inbox fa-2x mb-3 d-block opacity-50" aria-hidden="true"></i>
								<span class="text-muted">{{
									t(
										'لا يوجد تجار مطابقون للمرشحات.',
										'No merchants match your filters.',
										'אין סוחרים התואמים למסננים.'
									)
								}}</span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>

</div>

<ng-template #createModal let-modal>
	<div class="modal-header">
		<h5 class="modal-title">{{ t('إنشاء اشتراك جديد لتاجر', 'Create New Subscription', 'יצירת מנוי חדש') }}</h5>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
	</div>
	<div class="modal-body">
		<form [formGroup]="createForm" class="row g-3">
			<div class="col-md-6">
				<label class="form-label">{{ t('التاجر', 'Merchant', 'סוחר') }} *</label>
				<ng-select
					[items]="merchantOptions"
					bindLabel="display_label"
					bindValue="merchant_id"
					[searchFn]="merchantSearchFn"
					[clearable]="true"
					[placeholder]="t('ابحث بالاسم أو رقم الهوية أو رقم التاجر', 'Search by name, ID number, or merchant ID', 'חיפוש לפי שם, מספר מזהה, או מספר סוחר')"
					formControlName="merchant_id"
				>
					<ng-template ng-option-tmp let-item="item">
						{{ getMerchantDisplayName(item) }} (#{{ item.merchant_id }})
						<span *ngIf="item.id_number"> - {{ item.id_number }}</span>
					</ng-template>
					<ng-template ng-label-tmp let-item="item">
						{{ getMerchantDisplayName(item) }} (#{{ item.merchant_id }})
						<span *ngIf="item.id_number"> - {{ item.id_number }}</span>
					</ng-template>
				</ng-select>
				<div class="invalid-feedback d-block" *ngIf="isInvalid('merchant_id')">
					{{ t('اختيار التاجر مطلوب', 'Merchant is required', 'בחירת סוחר היא חובה') }}
				</div>
			</div>

			<div class="col-md-6">
				<label class="form-label">{{ t('الخطة', 'Plan', 'תוכנית') }} *</label>
				<select class="form-select" formControlName="plan_id">
					<option [ngValue]="null">{{ t('اختر الخطة', 'Select plan', 'בחר תוכנית') }}</option>
					<option *ngFor="let p of planOptions" [ngValue]="p.id">
						{{ getPlanOptionLabel(p) }} (#{{ p.id }})
					</option>
				</select>
				<div class="form-text">
					{{ t('تعرض فقط الخطط الرئيسية الفعالة.', 'Only active main plans are listed.', 'מוצגות רק תוכניות ראשיות פעילות.') }}
				</div>
				<div class="invalid-feedback d-block" *ngIf="isInvalid('plan_id')">
					{{ t('اختيار الخطة مطلوب', 'Plan is required', 'בחירת תוכנית היא חובה') }}
				</div>
			</div>

			<div class="col-md-6">
				<label class="form-label">{{ t('تاريخ البداية', 'Start Date', 'תאריך התחלה') }} *</label>
				<input type="datetime-local" class="form-control" formControlName="start_date" />
				<div class="form-text">
					{{ t('يمكن إدخال تاريخ سابق أو حالي حسب السياسة.', 'Past or current date is allowed.', 'ניתן לבחור תאריך עבר או נוכחי.') }}
				</div>
				<div class="invalid-feedback d-block" *ngIf="isInvalid('start_date')">
					{{ t('تاريخ البداية مطلوب', 'Start date is required', 'תאריך התחלה הוא חובה') }}
				</div>
			</div>

			<div class="col-md-6">
				<label class="form-label">{{ t('طريقة التفعيل', 'Activation Mode', 'מצב הפעלה') }} *</label>
				<select class="form-select" formControlName="activation_mode">
					<option value="admin_grant">{{ t('تفعيل مباشر بواسطة الأدمن', 'Admin Grant (Direct Activation)', 'הפעלה ישירה ע"י מנהל') }}</option>
					<option value="payment_link">{{ t('إنشاء رابط دفع', 'Payment Link', 'יצירת קישור תשלום') }}</option>
				</select>
				<div class="form-text">
					{{ t('عند اختيار رابط الدفع سيتم إنشاء رابط ولن يُفعّل الاشتراك إلا بعد نجاح الدفع.', 'Payment link creates an order and activates after successful payment callback.', 'קישור תשלום יוצר הזמנה והמנוי יופעל לאחר תשלום מוצלח.') }}
				</div>
			</div>

			<div class="col-md-6">
				<label class="form-label">{{ t('لغة الدفع', 'Payment Language', 'שפת תשלום') }}</label>
				<select class="form-select" formControlName="language">
					<option value="ar">Arabic</option>
					<option value="en">English</option>
					<option value="he">Hebrew</option>
				</select>
			</div>
		</form>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">
			{{ t('إغلاق', 'Close', 'סגור') }}
		</button>
		<button class="btn btn-dark" type="button" (click)="createSubscription()">
			<i class="fa fa-check-circle mx-1"></i>{{ t('إنشاء الاشتراك', 'Create Subscription', 'יצירת מנוי') }}
		</button>
	</div>
</ng-template>

<ng-template #extensionModal let-modal>
	<div class="modal-header">
		<h5 class="modal-title">{{ t('تمديدات وتعديل الاشتراك', 'Extensions & Manual Adjustment', 'הארכות והתאמה ידנית') }}</h5>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
	</div>
	<div class="modal-body">
		<ul class="nav nav-pills mb-3">
			<li class="nav-item">
				<button class="nav-link" [class.active]="activeExtensionTab === 'grant'" (click)="activeExtensionTab='grant'">
					{{ t('تمديد من الأدمن', 'Admin Extension', 'הארכה ע"י מנהל') }}
				</button>
			</li>
			<li class="nav-item">
				<button class="nav-link" [class.active]="activeExtensionTab === 'manual'" (click)="activeExtensionTab='manual'">
					{{ t('تعديل يدوي مباشر', 'Manual Adjust', 'התאמה ידנית') }}
				</button>
			</li>
		</ul>

		<form *ngIf="activeExtensionTab === 'grant'" [formGroup]="extensionForm" class="row g-3">
			<div class="col-md-6">
				<label class="form-label">{{ t('التاجر', 'Merchant', 'סוחר') }} *</label>
				<ng-select
					[items]="merchantOptions"
					bindLabel="display_label"
					bindValue="merchant_id"
					[searchFn]="merchantSearchFn"
					[clearable]="true"
					[placeholder]="t('ابحث بالاسم أو رقم الهوية أو رقم التاجر', 'Search by name, ID number, or merchant ID', 'חיפוש לפי שם, מספר מזהה, או מספר סוחר')"
					formControlName="merchant_id"
				>
					<ng-template ng-option-tmp let-item="item">
						{{ getMerchantDisplayName(item) }} (#{{ item.merchant_id }})
						<span *ngIf="item.id_number"> - {{ item.id_number }}</span>
					</ng-template>
					<ng-template ng-label-tmp let-item="item">
						{{ getMerchantDisplayName(item) }} (#{{ item.merchant_id }})
						<span *ngIf="item.id_number"> - {{ item.id_number }}</span>
					</ng-template>
				</ng-select>
				<div class="invalid-feedback d-block" *ngIf="isInvalidInForm(extensionForm, 'merchant_id')">
					{{ t('اختيار التاجر مطلوب', 'Merchant is required', 'בחירת סוחר היא חובה') }}
				</div>
			</div>

			<div class="col-md-6">
				<label class="form-label">{{ t('نوع التمديد', 'Extension Type', 'סוג הארכה') }} *</label>
				<select class="form-select" formControlName="extension_type" (change)="onExtensionTypeChange()">
					<option value="doc">{{ t('تمديد مستندات', 'Document Extension', 'הארכת מסמכים') }}</option>
					<option value="company">{{ t('تمديد شركات', 'Company Extension', 'הארכת חברות') }}</option>
					<option value="token">{{ t('تمديد توكنات التحليل', 'Analysis token extension', 'הארכת טוקני ניתוח') }}</option>
				</select>
			</div>

			<div class="col-md-6">
				<label class="form-label">{{ t('خطة التمديد', 'Extension Plan', 'תוכנית הארכה') }} *</label>
				<select class="form-select" formControlName="plan_id">
					<option [ngValue]="null">{{ t('اختر الخطة', 'Select plan', 'בחר תוכנית') }}</option>
					<option *ngFor="let p of extensionPlanOptions" [ngValue]="p.id">
						{{ getPlanOptionLabel(p) }} (#{{ p.id }})
					</option>
				</select>
				<div class="invalid-feedback d-block" *ngIf="isInvalidInForm(extensionForm, 'plan_id')">
					{{ t('اختيار خطة التمديد مطلوب', 'Extension plan is required', 'בחירת תוכנית הארכה היא חובה') }}
				</div>
			</div>

			<div class="col-md-6">
				<label class="form-label">{{ t('طريقة التنفيذ', 'Activation Mode', 'מצב הפעלה') }} *</label>
				<select class="form-select" formControlName="activation_mode">
					<option value="admin_grant">{{ t('تفعيل مباشر بواسطة الأدمن', 'Admin Grant (Direct)', 'הפעלה ישירה ע"י מנהל') }}</option>
					<option value="payment_link">{{ t('إنشاء رابط دفع', 'Payment Link', 'יצירת קישור תשלום') }}</option>
				</select>
			</div>

			<div class="col-md-6">
				<label class="form-label">{{ t('لغة الدفع', 'Payment Language', 'שפת תשלום') }}</label>
				<select class="form-select" formControlName="language">
					<option value="ar">Arabic</option>
					<option value="en">English</option>
					<option value="he">Hebrew</option>
				</select>
			</div>
		</form>

		<form *ngIf="activeExtensionTab === 'manual'" [formGroup]="manualAdjustForm" class="row g-3">
			<div class="col-md-12">
				<label class="form-label">{{ t('التاجر', 'Merchant', 'סוחר') }} *</label>
				<ng-select
					[items]="merchantOptions"
					bindLabel="display_label"
					bindValue="merchant_id"
					[searchFn]="merchantSearchFn"
					[clearable]="true"
					[placeholder]="t('ابحث بالاسم أو رقم الهوية أو رقم التاجر', 'Search by name, ID number, or merchant ID', 'חיפוש לפי שם, מספר מזהה, או מספר סוחר')"
					formControlName="merchant_id"
				>
					<ng-template ng-option-tmp let-item="item">
						{{ getMerchantDisplayName(item) }} (#{{ item.merchant_id }})
						<span *ngIf="item.id_number"> - {{ item.id_number }}</span>
					</ng-template>
					<ng-template ng-label-tmp let-item="item">
						{{ getMerchantDisplayName(item) }} (#{{ item.merchant_id }})
						<span *ngIf="item.id_number"> - {{ item.id_number }}</span>
					</ng-template>
				</ng-select>
				<div class="invalid-feedback d-block" *ngIf="isInvalidInForm(manualAdjustForm, 'merchant_id')">
					{{ t('اختيار التاجر مطلوب', 'Merchant is required', 'בחירת סוחר היא חובה') }}
				</div>
			</div>

			<div class="col-md-6 col-lg-3">
				<label class="form-label">{{ t('إضافة مستندات', 'Extra Documents', 'מסמכים נוספים') }}</label>
				<input type="number" min="0" class="form-control" formControlName="extra_documents" />
			</div>
			<div class="col-md-6 col-lg-3">
				<label class="form-label">{{ t('إضافة شركات', 'Extra Companies', 'חברות נוספות') }}</label>
				<input type="number" min="0" class="form-control" formControlName="extra_companies" />
			</div>
			<div class="col-md-6 col-lg-3">
				<label class="form-label">{{ t('إضافة أيام', 'Extra Days', 'ימים נוספים') }}</label>
				<input type="number" min="0" class="form-control" formControlName="extra_days" />
			</div>
			<div class="col-md-6 col-lg-3">
				<label class="form-label">
					<i class="fa fa-magic text-warning me-1" aria-hidden="true"></i>
					{{ t('توكنات تحليل إضافية (extra_tokens)', 'Extra analysis tokens (extra_tokens)', 'טוקני ניתוח נוספים (extra_tokens)') }}
				</label>
				<input type="number" min="0" class="form-control" formControlName="extra_tokens" autocomplete="off" />
				<div class="form-text small">
					{{
						t(
							'يُرسل للخادم كـ extra_tokens ويُضاف لرصيد توكنات تحليل المصاريف.',
							'Sent to the API as extra_tokens; adds to expense analysis token balance.',
							'נשלח ל-API כ-extra_tokens ומתווסף ליתרת טוקני ניתוח הוצאות.'
						)
					}}
				</div>
				<div class="invalid-feedback d-block" *ngIf="isInvalidInForm(manualAdjustForm, 'extra_tokens')">
					{{ t('أدخل عدداً صحيحاً غير سالب', 'Enter a non-negative integer', 'הזן מספר שלם שאינו שלילי') }}
				</div>
			</div>
			<div class="col-12 form-text">
				{{
					t(
						'أدخل قيمة واحدة على الأقل أكبر من صفر (مستندات، شركات، أيام، أو توكنات).',
						'Enter at least one value greater than zero (documents, companies, days, or tokens).',
						'הזן לפחות ערך אחד גדול מאפס (מסמכים, חברות, ימים או טוקנים).'
					)
				}}
			</div>
		</form>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">
			{{ t('إغلاق', 'Close', 'סגור') }}
		</button>
		<button *ngIf="activeExtensionTab === 'grant'" class="btn btn-dark" type="button" (click)="createMerchantExtension()">
			{{ t('تنفيذ التمديد', 'Apply Extension', 'החל הארכה') }}
		</button>
		<button *ngIf="activeExtensionTab === 'manual'" class="btn btn-dark" type="button" (click)="applyManualAdjust()">
			{{ t('تنفيذ التعديل', 'Apply Adjustment', 'החל התאמה') }}
		</button>
	</div>
</ng-template>

<ng-template #detailsModal let-modal>
	<div class="modal-header">
		<h5 class="modal-title">
			{{ t('تفاصيل التاجر', 'Merchant Details', 'פרטי סוחר') }}:
			{{ selectedMerchantId ? getMerchantName(selectedMerchantId) : '-' }}
			<span *ngIf="selectedMerchantId">(#{{ selectedMerchantId }})</span>
		</h5>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
	</div>
	<div class="modal-body">
		<div *ngIf="isDetailsLoading" class="text-center py-4">
			<span class="spinner-border spinner-border-sm"></span>
		</div>

		<ng-container *ngIf="!isDetailsLoading">
			<div class="merchant-details-card mb-4" *ngIf="selectedMerchantId as merchantId">
				<h6 class="mb-3">{{ t('بيانات التاجر', 'Merchant information', 'פרטי סוחר') }}</h6>
				<div class="row g-3">
					<div class="col-md-6">
						<strong>{{ t('الاسم', 'Name', 'שם') }}:</strong>
						{{ getMerchantName(merchantId) }}
					</div>
					<div class="col-md-3">
						<strong>{{ t('رقم التاجر', 'Merchant ID', 'מספר סוחר') }}:</strong>
						#{{ merchantId }}
					</div>
					<div class="col-md-3" *ngIf="getMerchantById(merchantId)?.id_number as idNumber">
						<strong>{{ t('رقم الهوية', 'ID number', 'מספר מזהה') }}:</strong>
						{{ idNumber }}
					</div>
					<div class="col-md-4" *ngIf="getMerchantById(merchantId)?.merchant_name_en">
						<strong>EN:</strong> {{ getMerchantById(merchantId)?.merchant_name_en }}
					</div>
					<div class="col-md-4" *ngIf="getMerchantById(merchantId)?.merchant_name_ar">
						<strong>AR:</strong> {{ getMerchantById(merchantId)?.merchant_name_ar }}
					</div>
					<div class="col-md-4" *ngIf="getMerchantById(merchantId)?.merchant_name_he">
						<strong>HE:</strong> {{ getMerchantById(merchantId)?.merchant_name_he }}
					</div>
				</div>
			</div>

			<div *ngIf="selectedMerchantStatus?.subscription" class="merchant-details-card mb-4">
				<h6 class="mb-3">{{ t('آخر حالة اشتراك', 'Latest subscription status', 'סטטוס מנוי אחרון') }}</h6>
				<div class="row g-3">
					<div class="col-md-3">
						<strong>{{ t('الحالة', 'Status', 'סטטוס') }}:</strong>
						{{ subscriptionEffectiveStatusLabel(selectedMerchantStatus.subscription) }}
					</div>
					<div class="col-md-3">
						<strong>{{ t('الخطة', 'Plan', 'תוכנית') }}:</strong>
						{{ getPlanDisplayName(selectedMerchantStatus.subscription.plan) }}
					</div>
					<div class="col-md-3">
						<strong>{{ t('متبقي أيام', 'Days Remaining', 'ימים נותרים') }}:</strong>
						{{ selectedMerchantStatus.days_remaining ?? '-' }}
					</div>
					<div class="col-md-3">
						<strong>{{ t('المستندات المتبقية', 'Documents Remaining', 'מסמכים נותרים') }}:</strong>
						{{ selectedMerchantStatus.documents_remaining ?? '-' }}
					</div>
					<div class="col-md-3">
						<strong>{{ t('الشركات المتبقية', 'Companies Remaining', 'חברות נותרות') }}:</strong>
						{{ selectedMerchantStatus.companies_remaining ?? '-' }}
					</div>
					<div class="col-md-3">
						<strong>{{ t('من', 'Start', 'התחלה') }}:</strong>
						{{ selectedMerchantStatus.subscription.start_date | date : 'dd/MM/yyyy' }}
					</div>
					<div class="col-md-3">
						<strong>{{ t('إلى', 'End', 'סיום') }}:</strong>
						{{ selectedMerchantStatus.subscription.end_date | date : 'dd/MM/yyyy' }}
					</div>
				</div>
			</div>

			<h6>{{ t('سجل الاشتراكات الكامل', 'Full subscription history', 'היסטוריית מנויים מלאה') }}</h6>
			<div class="table-responsive mb-4">
				<table class="table table-sm table-bordered align-middle">
					<thead>
						<tr>
							<th>#</th>
							<th>{{ t('الخطة', 'Plan', 'תוכנית') }}</th>
							<th>{{ t('الحالة', 'Status', 'סטטוס') }}</th>
							<th>{{ t('من', 'Start', 'התחלה') }}</th>
							<th>{{ t('إلى', 'End', 'סיום') }}</th>
							<th>{{ t('المستندات', 'Documents', 'מסמכים') }}</th>
							<th>{{ t('الشركات', 'Companies', 'חברות') }}</th>
							<th>{{ t('تاريخ الإنشاء', 'Created', 'נוצר') }}</th>
							<th>{{ t('تاريخ التحديث', 'Updated', 'עודכן') }}</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let h of (selectedMerchantHistory?.subscriptions || []); let i = index">
							<td>{{ i + 1 }}</td>
							<td>{{ getPlanDisplayName(h.plan) }}</td>
							<td>
								<span class="badge rounded-pill subscriptions-status subscriptions-status--{{ getEffectiveSubscriptionStatus(h) }}">
									{{ getHistoryEffectiveStatusLabel(h) }}
								</span>
							</td>
							<td>{{ h.start_date | date : 'dd/MM/yyyy' }}</td>
							<td>{{ h.end_date | date : 'dd/MM/yyyy' }}</td>
							<td>{{ formatHistoryDocumentsUsage(h) }}</td>
							<td>{{ formatHistoryCompaniesUsage(h) }}</td>
							<td>{{ h.created_at ? (h.created_at | date : 'dd/MM/yyyy HH:mm') : '-' }}</td>
							<td>{{ h.updated_at ? (h.updated_at | date : 'dd/MM/yyyy HH:mm') : '-' }}</td>
						</tr>
						<tr *ngIf="!(selectedMerchantHistory?.subscriptions || []).length">
							<td colspan="9" class="text-muted">{{ t('لا يوجد سجل', 'No history', 'אין היסטוריה') }}</td>
						</tr>
					</tbody>
				</table>
			</div>

			<h6>{{ t('آخر الطلبات', 'Recent Orders', 'הזמנות אחרונות') }}</h6>
			<div class="table-responsive">
				<table class="table table-sm table-bordered">
					<thead>
						<tr>
							<th>#</th>
							<th>{{ t('رقم الطلب', 'Order ID', 'מספר הזמנה') }}</th>
							<th>{{ t('النوع', 'Type', 'סוג') }}</th>
							<th>{{ t('الحالة', 'Status', 'סטטוס') }}</th>
							<th>{{ t('المبلغ', 'Amount', 'סכום') }}</th>
							<th>{{ t('التاريخ', 'Date', 'תאריך') }}</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let o of (selectedMerchantHistory?.recent_orders || []); let i = index">
							<td>{{ i + 1 }}</td>
							<td>{{ o.order_id }}</td>
							<td>{{ o.type }}</td>
							<td>{{ o.status }}</td>
							<td>{{ o.amount }}</td>
							<td>{{ o.created_at | date : 'dd/MM/yyyy HH:mm' }}</td>
						</tr>
						<tr *ngIf="!(selectedMerchantHistory?.recent_orders || []).length">
							<td colspan="6" class="text-muted">{{ t('لا توجد طلبات', 'No orders', 'אין הזמנות') }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</ng-container>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">
			{{ t('إغلاق', 'Close', 'סגור') }}
		</button>
	</div>
</ng-template>
